<!--
 * @Author: shijian.chen
 * @Date: 2021-11-09 16:52:12
 * @LastEditTime: 2022-06-22 19:04:15
 * @LastEditors: shijianchen shijianchen@tujia.com
 * @Description: 领克广告
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/ftms/index.vue
-->
<template>
  <div id="liyang">
    <div class="banner"></div>
    <div class="box">
      <video-comp
        poster="https://source.qunarzz.com/site/images/wns/20220622-shijianchen-liyang-2.png"
        src="https://source.qunarzz.com/site/images/wns/20220622-shijianchen-liyang-1.mp4"
      ></video-comp>
      <div class="content">
        “上有天堂，下有苏杭；出了苏杭，美在溧阳”，大美溧阳位于江苏省西南，地处长三角几何中心，交通便捷，生态优美，是国家全域旅游示范区、全国文明城市、世界长寿之乡。溧阳自秦时建县，历史悠久，人杰地灵，蔡邕斫焦尾琴、孟郊作《游子吟》于溧阳。全市林木覆盖率达31%，被誉为“天然氧吧”。5A级景区天目湖是江南精致山水典范，南山竹海坐拥35000亩翠竹。溧阳“1号公路”串联全域最美山水，精品民宿品牌“清风朗月·溧阳茶舍”引领乡村旅游发展。在溧阳，可长居可小憩，可创业可旅游，可挥洒青春可安养晚年。到溧阳，就是一种生活方式。
      </div>
    </div>
    <div class="title1"></div>
    <lineComp2 :lineList="lineList1" />
    <a
      class="lookMore"
      href="https://touch.qunar.com/hotelcn/liyang/?bd_source=travel_touch&city=%E6%BA%A7%E9%98%B3%E5%B8%82&checkInDate=2022-06-22&checkOutDate=2022-06-23&cityUrl=liyang&sort=0&localSearch=0"
      >查看更多</a
    >
    <div class="title2"></div>
    <lineComp2 class="lineComp2" :lineList="lineList2" />
    <a
      class="lookMore"
      href="https://touch.go.qunar.com/297873/sights?from=mobile"
      >查看更多</a
    >
    <div class="title3"></div>
    <lineComp />
    <a class="lookMore" href="https://touch.go.qunar.com/297873?from=mobile"
      >查看更多</a
    >
  </div>
</template>
<script>
import appoint from './components/appoint.vue';
import lineComp from './components/line.vue';
import videoComp from './components/video.vue';
import lineComp2 from './components/line2.vue';
export default {
  components: {
    appoint,
    lineComp,
    videoComp,
    lineComp2,
  },
  data() {
    return {
      lineList1: [
        [
          {
            headImg:
              'https://himg1.qunarzz.com/imgs/202109/04/C.uK-_7Gc2RwawQvyEG1024.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 484,
            desc: '天目湖宾馆',
            tag: '服务贴心/早餐很赞/环境很好',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=changzhou_2009&type=0&checkInDate=2022-06-15&checkOutDate=2022-06-16',
            discountId: '3401723685',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220622-shijianchen-111.jpeg',
            tagList: ['雪山温泉', '草原'],
            tag: '服务贴心/环境很好',
            price: 645,
            desc: '天目湖涵田度假村',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=changzhou_2881&type=0&checkInDate=2022-06-15&checkOutDate=2022-06-16',
            discountId: '1534603695',
          },
        ],
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220622-shijianchen-222.jpeg',
            tagList: ['网红打卡', '自驾游'],
            tag: '服务贴心/环境舒适',
            price: 1917,
            desc: '溧阳美岕山野温泉度假村',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=changzhou_6950&type=0&checkInDate=2022-06-15&checkOutDate=2022-06-16',
            discountId: '4078494581',
          },
          {
            headImg:
              'https://himg1.qunarzz.com/imgs/202101/31/C.Qkab1XfvG2h9YPZef1024.jpg',
            tagList: ['熊猫基地', '探秘'],
            tag: '服务贴心/早餐很赞',
            price: 575,
            desc: '溧阳万豪酒店',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=changzhou_10547&type=0',
            discountId: '2625878855',
          },
        ],
      ],
      lineList2: [
        [
          {
            headImg:
              'http://img1.qunarzz.com/sight/p0/2005/4f/4f877b91ca38cad0a3.water.jpg_600x330_f28b5b7f.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 69,
            desc: '南山竹海(AAAAA景区)',
            tag: '漫步在壮阔的竹林间',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=2270260929&from=android',
            discountId: '3401723685',
          },
          {
            headImg:
              'http://img1.qunarzz.com/sight/p0/1506/73/737f092551297176.water.jpg_600x330_e5814aec.jpg',
            tagList: ['雪山温泉', '草原'],
            tag: '既刺激又能亲子的嬉水乐园',
            price: 79,
            desc: '天目湖水世界',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=2883079419&from=android',
            discountId: '1534603695',
          },
        ],
        [
          {
            headImg:
              'http://img1.qunarzz.com/sight/p0/1606/fb/fb6e49e1d154a117e2.img.jpg_600x330_7a5f9da7.jpg',
            tagList: ['网红打卡', '自驾游'],
            tag: '体验桃李芬芳的田园美景',
            price: 121.3,
            desc: '竹海漂流',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=268376344&from=android',
            discountId: '4078494581',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220622-shijianchen-liyang-11.jpeg',
            tagList: ['熊猫基地', '探秘'],
            tag: '体验实景火车主题度假区',
            price: 26,
            desc: '曹山火车来斯',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=999050214&from=ios',
            discountId: '2625878855',
          },
        ],
      ],
    };
  },
  swiper2: null,
  swiper1: null,
  name: 'app',
  mounted() {
    this.initSwiper();
    let self = this;
    this.swipervideo = new Swiper('#audi .swipervideo-container', {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: '#audi .swipervideo-container .swiper-pagination',
      },
      on: {
        slideChange() {
          self.videoList.forEach((item, index) => {
            if (index != this.realIndex) {
              self.$refs['video' + index][0].pause();
            }
          });
        },
        resize: function () {
          //窗口变化了
        },
      },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    new Swiper('#audi .swiper1-container', {
      loop: true,
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: '#audi .swiper1-container .swiper-pagination',
      },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    new Swiper('#audi .swipebeauty-container', {
      loop: true,
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      pagination: {
        el: '#audi .swipebeauty-container .swiper-pagination',
      },
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    });
    this.imgs.forEach((item, index) => {
      new Swiper('#audi .swiper' + (index + 2) + '-container', {
        autoplay: {
          delay: 3000, //1秒切换一次
        },
        thumbs: {
          swiper: new Swiper(
            '#audi .swiper' + (index + 2) + '-thumbs-container',
            {
              slidesPerView: item.length,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
            },
          ),
        },
      });
    });
  },
  methods: {
    calcSize(index) {
      return document.querySelectorAll('.tab')[index]
        ? document.querySelectorAll('.tab')[index].offsetTop -
            (8 * window.innerWidth) / 375
        : 0;
    },
    playing() {
      this.swipervideo.autoplay.stop();
    },
    initSwiper() {
      this.$nextTick(() => {
        this.swiper2 = new Swiper('#frontlander .swiper2', {
          slidesPerView: 3,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });
        this.swiper1 = new Swiper('#frontlander .swiper1', {
          autoplay: {
            delay: 3000, //1秒切换一次
          },
          spaceBetween: 5,
          loop: false,
          initialSlide: 0,
          loopedSlides: 5, //looped slides should be the same
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: this.swiper2,
          },
        });
      });
    },
    setActive(index) {
      this.activeIndex = index;
      this.showSwiper = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.showSwiper = true;
        this.initSwiper();
      }, 0);
    },
  },
};
</script>
<style lang='less' scoped='true'>
img {
  display: block;
}
#liyang {
  height: 2226px;
  // background: url(https://source.qunarzz.com/site/images/wns/20220621-shijianchen-liyang-1.jpg)
  //   no-repeat;
  // background-size: 100% auto;
  background: #3e7872;
}
.banner {
  height: 355px;
  background: url(https://source.qunarzz.com/site/images/wns/20220621-shijianchen-liyang-1.jpg)
    no-repeat;
  background-size: 100% auto;
  overflow-y: hidden;
}
.title1{
  height:80px;
  background: url(https://source.qunarzz.com/site/images/wns/20220621-shijianchen-liyang-1.jpg)
    no-repeat;
  background-size: 100% auto;
  overflow-y: hidden;
  background-position-y: -758px;
}
.title2{
  height:80px;
  background: url(https://source.qunarzz.com/site/images/wns/20220621-shijianchen-liyang-1.jpg)
    no-repeat;
  background-size: 100% auto;
  overflow-y: hidden;
  background-position-y: -1305px;
}
.title3{
  height:80px;
  background: url(https://source.qunarzz.com/site/images/wns/20220621-shijianchen-liyang-1.jpg)
    no-repeat;
  background-size: 100% auto;
  overflow-y: hidden;
  background-position-y: -1856px;
}
.box {
  width: 354px;
  margin-left: auto;
  margin-right: auto;
  height: 402px;
  background: linear-gradient(0deg, #41a39e 0%, #3ebdbd 100%);
  border-radius: 7px;
  padding: 10px;
  box-sizing: border-box;
}
.content {
  height: 180px;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
  color: rgba(234, 245, 241, 1);
  text-align: center;
}
.lineComp2 {
  // margin-top: 100px;
}
.lookMore {
  width: 59px;
  color: #97dadc;
  display: block;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>